import React, { useState } from "react";
import "./../../css/Skills.css";
import Sidebar from './../../components/sidebar';

const AccommodationPage = () => {
  const [description, setDescription] = useState("");
  const [proficiencyLevel, setProficiencyLevel] = useState(0);
  const [dateAcquired, setDateAcquired] = useState("2024-12-27T16:33:01.199Z");
  const [category, setCategory] = useState("");
  const [isCertified, setIsCertified] = useState(true);

  const handleAccommodationImageChange = (e) => {
    const file = e.target.files[0];
    console.log("Selected file:", file);
    // Handle file upload or preview
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Description:", description);
    console.log("Proficiency Level:", proficiencyLevel);
    console.log("Date Acquired:", dateAcquired);
    console.log("Category:", category);
    console.log("Is Certified:", isCertified);
  };

  return (
    <>
    <Sidebar />
      <div className="accommodation-page">
        <div className="form-container">
          <h1 className="text-center title">Add New Skills</h1>
          <form onSubmit={handleSubmit}>
            {/* Accommodation Image */}
            <div className="form-group">
              <label htmlFor="accommodation-image">Slill Image</label>
              <input
                type="file"
                id="accommodation-image"
                onChange={handleAccommodationImageChange}
                accept="image/*"
              />
            </div>

            {/* Description */}
            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Describe the accommodation"
                rows="4"
              ></textarea>
            </div>

            {/* Proficiency Level */}
            <div className="form-group">
              <label htmlFor="proficiencyLevel">Proficiency Level</label>
              <input
                type="number"
                id="proficiencyLevel"
                value={proficiencyLevel}
                onChange={(e) => setProficiencyLevel(Number(e.target.value))}
                placeholder="Enter proficiency level"
              />
            </div>

            {/* Date Acquired */}
            <div className="form-group">
              <label htmlFor="dateAcquired">Date Acquired</label>
              <input
                type="datetime-local"
                id="dateAcquired"
                value={dateAcquired}
                onChange={(e) => setDateAcquired(e.target.value)}
              />
            </div>

            {/* Category */}
            <div className="form-group">
              <label htmlFor="category">Category</label>
              <input
                type="text"
                id="category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                placeholder="Enter category"
              />
            </div>

            {/* Is Certified */}
            <div className="form-group">
              <label htmlFor="isCertified">Is Certified</label>
              <input
                type="checkbox"
                id="isCertified"
                checked={isCertified}
                onChange={(e) => setIsCertified(e.target.checked)}
              />
            </div>

            {/* Submit Button */}
            <button type="submit" className="submit-btn">
              Submit Accommodation
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default AccommodationPage;
